<template>
    <div v-if="!pending && !actionMessage?.hidden && actionMessage?.code" class="p-4 md:p-6 justify-between rounded-xl shadow-md transition-all duration-300 ease-in"
        v-bind:class="{
            'opacity-0': !active,
            'bg-white dark:bg-gray-900': !secondaryBg,
            'bg-blue-100 dark:bg-gray-700': secondaryBg,
            'bg-green-400 border-green-800 dark:bg-green-900 dark:border-green-600': actionMessage?.color == 'success',
            'bg-red-400 text-white border-red-700 dark:bg-red-900 dark:border-red-600': actionMessage?.color == 'warning',
            '': actionMessage?.color == 'info',
        }">
            <DynamicData :getData="() => find('action-messages', {filters: { code: { $eq: actionMessage.code } } })"
                :dataKey="'actionMessage-'+actionMessage.code" v-slot="{ data: message, pending: messagePending }">
                <div v-if="!messagePending && message?.data?.length > 0" class="flex flex-wrap items-center justify-between gap-5">
                    <div class="transition-all duration-300 delay-75" v-bind:class="{'opacity-0 -translate-x-5': !active}">
                        <div class="text-lg font-bold" v-bind:class="{'bg-blue-100 dark:bg-gray-600 rounded w-1/3 h-6 animate-pulse text text-transparent': messagePending}">
                            {{ message?.data?.[0].attributes?.title }}
                        </div>
                        <div class="" v-bind:class="{'bg-blue-100 dark:bg-gray-600 rounded w-2/3 h-6 animate-pulse text text-transparent': messagePending}">
                            {{ message?.data?.[0].attributes?.message }}
                        </div>
                    </div>
                    <NuxtLink v-if="actionMessage.to" :to="actionMessage.to"
                        class="transition-all duration-300 delay-200" v-bind:class="{'opacity-0 translate-x-5': !active}">
                        <ElementsButton>
                            {{ message?.data?.[0].attributes?.buttonText ?? 'Ansehen' }}
                        </ElementsButton>
                    </NuxtLink>
                </div>
            </DynamicData>
    </div>
</template>
<script setup>
const props = defineProps({
    actionMessage: { default: null },
    pending: { type: Boolean, required: true, default: true },
    secondaryBg: { type: Boolean, default: false },
})

const { find } = useStrapi4()

const active = ref(false)
onMounted(function(){
    setTimeout(function(){ active.value = true }, 100)
})
onBeforeUnmount(() => active.value = false )
</script>